import { createTheme } from '@mui/material/styles'

// Wallboard themes: dark (default — TVs often hang in dim crew rooms) and
// light, chosen per board in the manager and toggleable on the display
// itself. Self-contained (the app theme is light-only), same Poppins type.
// `palette.viz` carries the chart/accent ink, validated per surface — widget
// components read it via useTheme() so they render correctly in both modes.

const PALETTES = {
  dark: {
    mode: 'dark',
    background: { default: '#0B1220', paper: '#151E30' },
    primary: { main: '#4FB3BF' },
    divider: 'rgba(148, 163, 184, 0.16)',
    text: { primary: '#F1F5F9', secondary: '#94A3B8' },
    viz: {
      series: '#4FB3BF',
      seriesSoft: 'rgba(79, 179, 191, 0.16)',
      grid: 'rgba(148, 163, 184, 0.14)',
      axisText: '#94A3B8',
      good: '#34D399',
      warning: '#FBBF24',
      critical: '#F87171',
      shoutout: '#C084FC',
    },
  },
  light: {
    mode: 'light',
    background: { default: '#F1F5F9', paper: '#FFFFFF' },
    primary: { main: '#1E7F88' },
    divider: 'rgba(15, 23, 42, 0.12)',
    text: { primary: '#0F172A', secondary: '#64748B' },
    viz: {
      series: '#1E7F88',
      seriesSoft: 'rgba(30, 127, 136, 0.10)',
      grid: '#E2E8F0',
      axisText: '#64748B',
      good: '#059669',
      warning: '#D97706',
      critical: '#DC2626',
      shoutout: '#9333EA',
    },
  },
}

export const buildWallboardTheme = (mode = 'dark') =>
  createTheme({
    palette: PALETTES[mode] ?? PALETTES.dark,
    typography: {
      fontFamily: 'Poppins, Roboto, sans-serif',
    },
    shape: { borderRadius: 10 },
  })

// Legacy export — the unlock screen always renders dark
export const wallboardTheme = buildWallboardTheme('dark')

export const makeChartOptions = (viz) => ({
  responsive: true,
  maintainAspectRatio: false,
  animation: false,
  interaction: { mode: 'index', intersect: false },
  plugins: {
    legend: { display: false },
    tooltip: { enabled: false },
  },
  scales: {
    x: {
      grid: { display: false },
      border: { color: viz.grid },
      ticks: { color: viz.axisText, font: { family: 'Poppins', size: 12 } },
    },
    y: {
      beginAtZero: true,
      border: { display: false },
      grid: { color: viz.grid, lineWidth: 1 },
      ticks: {
        precision: 0,
        color: viz.axisText,
        font: { family: 'Poppins', size: 12 },
        maxTicksLimit: 5,
      },
    },
  },
})
